export default {
  en: 'GB',
  en_ie: 'IE',
  ar_SA: 'sa',
}
